import { create } from "zustand";

export const enum Section {
  Header = "header",
  Menu = "menu",
  Footer = "footer",
}

interface SectionStore {
  activeSection: Section;
  setActiveSection: (section: Section) => void;
}

export const useSectionStore = create<SectionStore>((set) => ({
  activeSection: Section.Header,
  setActiveSection: (section) => {
    set({ activeSection: section });
  },
}));
